import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import './heritage-plates-auction.css';

const HeritagePlatesAuctionPage = () => {
  const { find, meta } = usePageContent('heritage-plates-auction');
  const seo = meta?.seo;
  useTitle(seo?.title || 'Heritage Plates Auction');
  useMeta(seo);
  const c = find('richText') || {};
  return (
    <div id="content">
      <div className="page-header heritage-auction-header">
        <div className="content-holder content-holder--indented">
          <h1 className="page-header__title">{c.pageTitle || 'Heritage Plates Auction'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented heritage-auction-body">
        <div className="rich-text heritage-auction-rich-text" dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }} />
      </div>
    </div>
  );
};

export default HeritagePlatesAuctionPage;
